<template>
  <div class="alert alert-primary" role="alert">
    <slot />
  </div>
</template>
<script lang="ts">
export default {
  name: 'Alert',
  props: {
    type: { type: String, default: 'Error' },
  },
}
</script>
